/**
 * Marketing analytics — Google Analytics 4 (GA4) + Meta (Facebook) Pixel.
 *
 * Both are loaded ONLY in production (process.env.NODE_ENV === 'production')
 * AND only when their respective IDs are configured via:
 *   - REACT_APP_GA_TRACKING_ID  (e.g. "G-XXXXXXXXXX")
 *   - REACT_APP_META_PIXEL_ID   (numeric pixel id)
 *
 * In dev / preview the scripts never load and `trackEvent` is a silent no-op,
 * so nothing breaks and no spurious hits are sent while building.
 */
const GA_ID = (process.env.REACT_APP_GA_TRACKING_ID || '').trim();
const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();
const IS_PROD = process.env.NODE_ENV === 'production';

export const ANALYTICS_ENABLED = IS_PROD && (Boolean(GA_ID) || Boolean(PIXEL_ID));

let initialized = false;

function injectGA() {
  if (!GA_ID || typeof document === 'undefined') return;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
}

function injectMetaPixel() {
  if (!PIXEL_ID || typeof document === 'undefined') return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** Initialise analytics scripts. Idempotent; production-only. */
export function initAnalytics() {
  if (initialized || !IS_PROD || typeof window === 'undefined') return;
  initialized = true;
  injectGA();
  injectMetaPixel();
}

/**
 * Fire a tracking event to GA4 and Meta Pixel (as a custom event).
 * No-op when analytics is not initialised / not in production.
 */
export function trackEvent(name, params = {}) {
  try {
    if (GA_ID && typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', name, params);
    }
    if (PIXEL_ID && typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', name, params);
    }
  } catch {
    /* never let analytics break the app */
  }
}
